<template>
  <v-data-iterator
    row
    wrap
    :items.sync="bannersByTag"
    :page.sync="ui.banners.page"
    :items-per-page.sync="ui.banners.perPage"
    :footer-props="{ 'items-per-page-options': [10, 30, 50, 100] }"
    item-key="_id"
    :loading="!!bannersByTag"
    sort-by="name"
    :sort-desc="sortDesc"
    :search.sync="ui.banners.search"
    :custom-filter="customFilter"
    :custom-sort="sortByCompanyName"
  >
    <template v-slot:header>
      <v-row class="mb-12">
        <v-toolbar flat>
          <v-text-field
            v-model="ui.banners.search"
            clearable
            hide-details
            single-line
            color="primary"
            label="Search by Advertiser"
            class="mr-3"
            prepend-inner-icon="mdi-magnify"
          >
          </v-text-field>
          <template>
            <Search
              class="search"
              :tags="loloTags"
              placeholder="Search by Tags"
            />
            <v-btn-toggle group color="primary" v-model="sortDesc" mandatory>
              <v-btn color="primary" text :value="false">
                <v-icon large>mdi-chevron-up</v-icon>
              </v-btn>
              <v-btn color="primary" text :value="true">
                <v-icon large>mdi-chevron-down</v-icon>
              </v-btn>
            </v-btn-toggle>
            <v-spacer></v-spacer>

            <v-btn
              v-if="role == 'ADMIN'"
              class="primary"
              tile
              width="245"
              height="60"
              text
              :to="{ name: 'dashboard.banner.create' }"
              >Add new banner</v-btn
            >
            <v-btn
              color="success"
              class="ml-2"
              tile
              elevation
              height="60"
              @click="updateBanners"
              :loading="isRefreshing"
              >Refresh</v-btn
            >
          </template>
        </v-toolbar>
      </v-row>
    </template>

    <!-- Content -->

    <template v-slot:default="props">
      <div class="banners-grid">
        <Banner
          v-for="(banner, index) in props.items"
          :key="banner._id"
          title
          :banner="banner"
          :counter="index"
        ></Banner>
      </div>
      <!-- </v-fade-transition> -->
    </template>
    <!-- Content -->
  </v-data-iterator>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapState, mapActions } from "vuex";
// import { BannerStatusService } from "@/common/services";
import ApiService from "@/common/services/banner";

export default Vue.extend({
  name: "DashbonardBannerList",
  components: {
    Banner: () => import("@/components/Dashboard/BannerThumb.vue"),
    Search: () => import("@/components/SearchAutocomplete"),
  },
  data() {
    return {
      itemsPerPageArray: [12, 24, 48],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 24,
      sortBy: "name",
      isRefreshing: false,
      currentTags: [],
    };
  },
  computed: {
    ...mapGetters(["role", "getTags"]),
    ...mapState(["banner", "ui"]),
    numberOfPages() {
      return Math.ceil(this.banner.banners.length / this.itemsPerPage);
    },
    loloTags() {
      return this.ui.banners.search ? this.currentTags : this.getTags;
    },
    bannersByTag() {
      let banners = this.banner.banners;
      const tagQuery = this.banner.tagQuery;
      // query.map(q => q.toLowerCase());

      // const search = this.search.toString().toLowerCase();
      // if (search.length > 2) {
      //   tagQuery = banners
      //     .filter(
      //       (item) =>
      //         item.company.name
      //           .toString()
      //           .toLowerCase()
      //           .indexOf(search) !== -1
      //     )
      //     .map((q) => q.toLowerCase());
      // }
      if (tagQuery.length == 0) return banners;

      banners = banners.filter((item) => {
        const substring = (item.tags || "").toLowerCase();
        const match = tagQuery.every((element) => {
          return substring.length > 0 && substring.indexOf(element) > -1;
        });
        return match;
      });

      return banners;
    },
  },
  mounted() {
    this.fetchBanners();
  },
  methods: {
    ...mapActions(["fetchBanners", "setSnackbar"]),
    async updateBanners() {
      this.isRefreshing = true;
      try {
        // const { status } =
        await ApiService.updateBanners();
        // console.log(status);
        await this.fetchBanners();
        this.setSnackbar({
          text: `Banners Updated.`,
        });
      } catch (err) {
        this.setSnackbar({
          text: `Advertisers fetched.`,
          color: "secondary",
        });
      }
      this.isRefreshing = false;
    },
    customBannerFilter() {
      return true;
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    customFilter(items, search) {
      if (search === null) return items;
      search = search.toString().toLowerCase();
      if (search.length < 2) return items;

      const filteredBanners = items.filter(
        (item) =>
          item.company.name
            .toString()
            .toLowerCase()
            .indexOf(search) !== -1
      );

      const currentBannerTags = filteredBanners
        .map((b) => (b.tags.length > 0 ? b.tags.split(";") : false))
        .flat()
        .sort();
      this.currentTags = [...new Set(currentBannerTags)];

      return filteredBanners;
      //   return value != null && search != null && typeof value === "string";
    },
    compareValues(order) {
      // Use toUpperCase() to ignore character casing
      return (a, b) => {
        const bandA = a.company.name;
        const bandB = b.company.name;

        let comparison = 0;
        if (bandA > bandB) {
          comparison = 1;
        } else if (bandA < bandB) {
          comparison = -1;
        }
        const sortDesc = order ? -1 : 1;

        return comparison * sortDesc;
      };
    },
    sortByCompanyName(items, sortBy, sortDesc) {
      const sorted = items.sort(this.compareValues(sortDesc[0]));
      return sorted;
    },
  },
});
</script>

<style lang="scss">
.banners {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.banners-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  grid-gap: 1rem;
  justify-content: center;
}
.nav-link.btn {
  padding: 0.2em 0.5em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ef3f37;
  cursor: pointer;
  color: #ef3f37;
  text-decoration: none;
  font-size: 18px;
  font-weight: 600;
  margin: 0 10px 10px 0;
  transition-property: border-color, color;
  transition-duration: 200ms;
  &:hover {
    background-color: rgba(239, 64, 55, 0.06);
    // color: #c1263e;
    // border-color: #c1263e;
  }
}
</style>
